export const INPUT_STYLE = {
  width: "100%",
  padding: "10px 12px",
  border: "1.5px solid #DDD",
  borderRadius: "6px",
  fontSize: "14px",
  outline: "none",
};

export const LABEL_STYLE = {
  fontSize: "12px",
  fontWeight: 600,
  color: "#666",
  display: "block",
  marginBottom: "4px",
};
